import React from "react";
import { CommonHeader } from "header-component";
import "./AngelAiHeader.css"
const CustomHeader = () => {
  return (
    <div>
     <CommonHeader IconColor="white"/>
    </div>
  );
};
export default CustomHeader;